import {
  Box, FormControl,
  MenuItem,
  TextField
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import styles from '../EntityEditor.styles';
import { entityTypes } from '../../../constants/field-constants';
// import StyledTextField from '../../styled-components/StyledTextField';
import React, {useState, useEffect} from 'react';
import EntityCompanyBlock from './EntityCompanyBlock';
import BirthYearField from '../../birth-year-field/BirthYearField';
import { LatinTextField } from '../../latin-text-field/LatinTextField';
import { NumericTextField } from '../../numeric-text-field/NumericTextField';
import { LinkTextField } from '../../link-text-field/LinkTextField';
import CityAutocomplete from "../../city-autocomplete/CityAutocomplete"
import ValidatedAccordion from '../../object-editor/object-editor-blocks/ValidatedAccordion';
import { StyledSelect, StyledInputLabel } from '../../styled-components/StyledSelect';
import { SelectChangeEvent } from '@mui/material/Select';

const genderOptions = [
  {
    label: 'Mr.',
    value: 'M'
  },
  {
    label: 'Ms.',
    value: 'V'
  },
  {
    label: 'M/V',
    value: ''
  }
];

const blackListedOptions = [
  {
    label: 'Yes',
    value: "true",
  },
  {
    label: 'No',
    value: "false"
  },
  {
    label: 'n/a',
    value: ''
  }
];

const isDeadOptions = [
  {
    label: 'Yes',
    value: 'false'
  },
  {
    label: 'No',
    value: 'true'
  },
  {
    label: 'n/a',
    value: ''
  }
];

const isResidentOptions = [
  {
    label: 'Yes',
    value: 'true'
  },
  {
    label: 'No',
    value: 'false'
  },
  {
    label: 'n/a',
    value: ''
  }
];

export const scrollLock = (flag: boolean) => {
  const element = document.getElementById("box-tabPanel");
  const elementModal = document.getElementById("container-entityObjectEditModal");
  const overflowValue = flag ? "hidden" : "";
  if (element) {
   element.style.overflowY = overflowValue;
  }
  if (elementModal) {
    elementModal.style.overflowY = overflowValue;
  }
};

const GeneralFieldsBlock = ({
                              entityType,
                              onChange,
                              entityFields,
                              entityCompany,
                              errors,
                              onChangeCompany,
                              min,
                              errorDate,
                              errorFields,
                              setErrorFields,
                              inputValue,
                              setInputValue,
                              inputValueCity,
                              setInputValueCity,
                            }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [expanded, setExpanded] = useState<null | "general_fields">("general_fields");
  useEffect(() => {
    scrollLock(isOpen);
    return () => {
      scrollLock(false);
    }
  }, [isOpen]);

 return (
   <ValidatedAccordion
     title="General fields *"
     hasErrors={!errors.isFilledLastName || Object.values(errorFields).includes(true) || !errors.isFilledCompanyName}
     expanded={expanded === "general_fields"}
     onChange={(isExp) => setExpanded(isExp ? "general_fields" : null)}
   >
        {entityType === entityTypes.PERSON ? (
          <>
            <Box sx={styles.fieldHolder}>
              <Box sx={styles.fieldBlock}>
                <LatinTextField
                  fullWidth
                  label="First name"
                  type="text"
                  name="first_name"
                  errorFields={errorFields.first_name}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.first_name}
                  onChange={(event) => onChange('generalFields', 'first_name', event.target.value)}
                />
                <LatinTextField
                  fullWidth
                  label="Prefix"
                  type="text"
                  name="prefix"
                  errorFields={errorFields.prefix}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.prefix}
                  onChange={(event) => onChange('generalFields', 'prefix', event.target.value)}
                />
                <LatinTextField
                  fullWidth
                  label="Last name"
                  required
                  type="text"
                  name="last_name"
                  errorFields={errorFields.last_name}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.last_name}
                  onChange={(event) => onChange('generalFields', 'last_name', event.target.value)}
                  error={!errors.isFilledLastName}
                />
                <LatinTextField
                  fullWidth
                  label="Initials"
                  type="text"
                  name="initials"
                  errorFields={errorFields.initials}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.initials}
                  onChange={(event) => onChange('generalFields', 'initials', event.target.value)}
                />
                <LatinTextField
                  fullWidth
                  label="All names"
                  type="text"
                  name="all_names"
                  errorFields={errorFields.all_names}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.all_names}
                  onChange={(event) => onChange('generalFields', 'all_names', event.target.value)}
                />
                <LatinTextField
                  fullWidth
                  label="Nickname"
                  type="text"
                  name="nick_name"
                  errorFields={errorFields.nick_name}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.nick_name}
                  onChange={(event) => onChange('generalFields', 'nick_name', event.target.value)}
                />
                <FormControl
                  fullWidth
                  margin="dense"
                  // sx={{ margin: "5px" }}
                >
                  <StyledInputLabel
                    id="select-gender-label"
                    htmlFor="select-gender-input"
                  >
                    Gender
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="select-gender-label"
                    id="select-gender"
                    name="selectGender"
                    value={entityFields?.gender || ''}
                    label="Gender"
                    onChange={(event: SelectChangeEvent) => onChange('generalFields', 'gender', event.target.value)}
                    inputProps={{
                      id: 'select-gender-input',
                    }}
                  >
                    {genderOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
                {/*<StyledTextField*/}
                {/*  fullWidth*/}
                {/*  select*/}
                {/*  label="Gender"*/}
                {/*  id="select-gender"*/}
                {/*  name="selectGender"*/}
                {/*  margin="dense"*/}
                {/*  defaultValue=""*/}
                {/*  value={entityFields?.gender || ''}*/}
                {/*  onChange={(e) => onChange('generalFields', 'gender', e, -1)}*/}
                {/*>*/}
                {/*  {genderOptions.map((option) => (*/}
                {/*    <MenuItem key={option.value} value={option.value}>*/}
                {/*      {option.label}*/}
                {/*    </MenuItem>*/}
                {/*  ))}*/}
                {/*</StyledTextField>*/}
                <FormControl
                  fullWidth
                  margin="dense"
                >
                  <StyledInputLabel
                    id="select-blacklisted-label"
                    htmlFor="select-blacklisted-input"
                  >
                    Blacklisted
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="select-blacklisted-label"
                    id="select-blacklisted"
                    name="selectBlacklisted"
                    value={entityFields?.blacklisted.toString() || ''}
                    label="Blacklisted"
                    onChange={(event: SelectChangeEvent) => onChange('generalFields', 'blacklisted', event.target.value)
                    }
                    inputProps={{
                      id: 'select-blacklisted-input',
                    }}
                  >
                    {blackListedOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
                {/*<StyledTextField*/}
                {/*  fullWidth*/}
                {/*  select*/}
                {/*  label="Blacklisted"*/}
                {/*  id="select-blacklisted"*/}
                {/*  name="selectBlacklisted"*/}
                {/*  margin="dense"*/}
                {/*  defaultValue=""*/}
                {/*  value={entityFields?.blacklisted.toString() || ''}*/}
                {/*  onChange={(e) =>*/}
                {/*    onChange('generalFields', 'blacklisted', e, -1)*/}
                {/*  }*/}
                {/*>*/}
                {/*  {blackListedOptions.map((option) => (*/}
                {/*    <MenuItem key={option.value} value={option.value}>*/}
                {/*      {option.label}*/}
                {/*    </MenuItem>*/}
                {/*  ))}*/}
                {/*</StyledTextField>*/}
                <FormControl
                  fullWidth
                  margin="dense"
                >
                  <StyledInputLabel
                    id="select-is-resident-label"
                    htmlFor="select-is-resident-input"
                  >
                    NL resident
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="select-is-resident-label"
                    id="select-is-resident"
                    name="selectIsResident"
                    value={entityFields?.is_resident.toString() || ''}
                    label="NL resident"
                    onChange={(event: SelectChangeEvent) => onChange('generalFields', 'is_resident', event.target.value)
                    }
                    inputProps={{
                      id: 'select-is-resident-input',
                    }}
                  >
                    {isResidentOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
                {/*<StyledTextField*/}
                {/*  fullWidth*/}
                {/*  select*/}
                {/*  label="NL resident"*/}
                {/*  id="select-resident"*/}
                {/*  name="selectResident"*/}
                {/*  margin="dense"*/}
                {/*  defaultValue=""*/}
                {/*  value={entityFields?.is_resident.toString() || ''}*/}
                {/*  onChange={(e) =>*/}
                {/*    onChange('generalFields', 'is_resident', e, -1)*/}
                {/*  }*/}
                {/*>*/}
                {/*  {isResidentOptions.map((option) => (*/}
                {/*    <MenuItem key={option.value} value={option.value}>*/}
                {/*      {option.label}*/}
                {/*    </MenuItem>*/}
                {/*  ))}*/}
                {/*</StyledTextField>*/}
              </Box>
              <Box sx={styles.fieldBlock}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="D.o.B"
                    value={entityFields?.birth_date ? dayjs(entityFields?.birth_date) : null}
                    minDate={dayjs(min)}
                    maxDate={dayjs()}
                    format="DD.MM.YYYY"
                    onOpen={() => setIsOpen(true)}
                    onClose={() => setIsOpen(false)}
                    onChange={(newValue, _keyboardInputValue) => {
                      if (newValue === null) {
                        onChange('generalFields', 'birth_date', newValue);
                        return;
                      }
                      onChange('generalFields', 'birth_date', dayjs(newValue)?.format('YYYY-MM-DD'));
                    }}
                    slots={{textField: TextField}}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        margin: "dense",
                        error: errorDate,
                        helperText: errorDate ? 'Please enter a date between 01-01-1900 and today' : ''
                      },
                    }}
                  />
                </LocalizationProvider>
                <BirthYearField
                  name="birth_year"
                  nameBlock="generalFields"
                  value={entityFields?.birth_year}
                  onChange={onChange}
                  setErrorFields={setErrorFields}
                  errorFields={errorFields}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                />
                <CityAutocomplete
                  label="P.o.B"
                  name="birth_place"
                  freeSolo
                  errorFields={errorFields?.birth_place}
                  setErrorFields={setErrorFields}
                  textFieldProps={{
                    fullWidth: true,
                    margin: "dense",
                    type: "text"
                  }}
                  value={entityFields?.birth_place ?? ""}
                  inputValue={inputValueCity}
                  setInputValue={setInputValueCity}
                  debounceMs={300}
                  minChars={3}
                  onChange={(event) => onChange('generalFields', 'birth_place', event.target.value)}
                  // onChange={(newValue) => onChange('generalFields', 'birth_place', newValue )}
                />
                <FormControl
                  fullWidth
                  margin="dense"
                >
                  <StyledInputLabel
                    id="select-is-dead-label"
                    htmlFor="select-is-dead-input"
                  >
                    Alive
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="select-is-dead-label"
                    id="select-is-dead"
                    name="selectIsDead"
                    value={entityFields?.is_dead.toString() || ''}
                    label="Alive"
                    onChange={(event: SelectChangeEvent) => onChange('generalFields', 'is_dead', event.target.value)
                    }
                    inputProps={{
                      id: 'select-is-dead-input',
                    }}
                  >
                    {isDeadOptions.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
                {/*<StyledTextField*/}
                {/*  fullWidth*/}
                {/*  select*/}
                {/*  label="Alive"*/}
                {/*  id="select-alive"*/}
                {/*  name="is_dead"*/}
                {/*  margin="dense"*/}
                {/*  defaultValue=""*/}
                {/*  value={entityFields?.is_dead.toString() || ''}*/}
                {/*  onChange={(e) => onChange('generalFields', 'is_dead', e, -1)}*/}
                {/*>*/}
                {/*  {isDeadOptions.map((option, index) => (*/}
                {/*    <MenuItem key={index} value={option.value}>*/}
                {/*      {option.label}*/}
                {/*    </MenuItem>*/}
                {/*  ))}*/}
                {/*</StyledTextField>*/}
                <NumericTextField
                  fullWidth
                  label="K.P.N."
                  type="text"
                  name="kadaster_personal_number"
                  errorFields={errorFields.kadaster_personal_number}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.kadaster_personal_number}
                  onChange={(event) => onChange('generalFields', 'kadaster_personal_number', event.target.value)}
                />
                <NumericTextField
                  fullWidth
                  label="Kad. Rechthebbende"
                  type="text"
                  name="kadaster_objects_amount"
                  errorFields={errorFields.kadaster_objects_amount}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.kadaster_objects_amount}
                  onChange={(event) => onChange('generalFields', 'kadaster_objects_amount', event.target.value)}
                />
                <LinkTextField
                  fullWidth
                  label="Kad. link"
                  type="text"
                  name="kadaster_url"
                  errorFields={errorFields.kadaster_url}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.kadaster_url}
                  onChange={(event) => onChange('generalFields', 'kadaster_url', event.target.value)}
                />
                <LinkTextField
                  fullWidth
                  label="Link"
                  type="text"
                  name="url"
                  errorFields={errorFields.url}
                  setErrorFields={setErrorFields}
                  margin="dense"
                  value={entityFields?.url}
                  onChange={(event) => onChange('generalFields', 'url', event.target.value)}
                />
              </Box>
            </Box>
            <EntityCompanyBlock
              onChange={onChangeCompany}
              entityCompany={entityCompany}
            />
          </>
        ) : (
          <Box sx={styles.fieldHolder}>
            <Box sx={styles.fieldBlock}>
              <LatinTextField
                fullWidth
                label="Company name"
                type="text"
                name="company_name"
                errorFields={errorFields.company_name}
                setErrorFields={setErrorFields}
                error={!errors.isFilledCompanyName}
                margin="dense"
                required
                value={entityFields?.company_name}
                onChange={(event) => onChange('generalFields', 'company_name', event.target.value)}
              />
              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  label="Company name"*/}
              {/*  margin="dense"*/}
              {/*  required*/}
              {/*  onChange={(e) =>*/}
              {/*    onChange('generalFields', 'company_name', e, -1)*/}
              {/*  }*/}
              {/*  value={entityFields?.company_name}*/}
              {/*  error={!errors.isFilledCompanyName}*/}
              {/*/>*/}

              <NumericTextField
                fullWidth
                label="KVK number"
                type="text"
                name="chamber_commerce_number"
                errorFields={errorFields.chamber_commerce_number}
                setErrorFields={setErrorFields}
                margin="dense"
                value={entityFields?.chamber_commerce_number}
                onChange={(event) => onChange('generalFields', 'chamber_commerce_number', event.target.value)}
              />

              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  label="KVK number"*/}
              {/*  margin="dense"*/}
              {/*  onChange={(e) =>*/}
              {/*    onChange('generalFields', 'chamber_commerce_number', e, -1)*/}
              {/*  }*/}
              {/*  value={entityFields?.chamber_commerce_number}*/}
              {/*/>*/}

              <LinkTextField
                fullWidth
                label="KVK link"
                type="text"
                name="chamber_commerce_url"
                errorFields={errorFields.chamber_commerce_url}
                setErrorFields={setErrorFields}
                margin="dense"
                value={entityFields?.chamber_commerce_url}
                onChange={(event) => onChange('generalFields', 'chamber_commerce_url', event.target.value)}
              />

              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  label="KVK link"*/}
              {/*  margin="dense"*/}
              {/*  onChange={(e) =>*/}
              {/*    onChange('generalFields', 'chamber_commerce_url', e, -1)*/}
              {/*  }*/}
              {/*  value={entityFields?.chamber_commerce_url}*/}
              {/*/>*/}

              <FormControl
                fullWidth
                margin="dense"
              >
                <StyledInputLabel
                  id="select-blacklisted-label"
                  htmlFor="select-blacklisted-input"
                >
                  Blacklisted
                </StyledInputLabel>
                <StyledSelect
                  labelId="select-blacklisted-label"
                  id="select-blacklisted"
                  name="selectBlacklisted"
                  value={entityFields?.blacklisted.toString() || ''}
                  label="Blacklisted"
                  onChange={(event: SelectChangeEvent) => onChange('generalFields', 'blacklisted', event.target.value)
                  }
                  inputProps={{
                    id: 'select-blacklisted-input',
                  }}
                >
                  {blackListedOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </StyledSelect>
              </FormControl>
              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  select*/}
              {/*  label="Blacklisted"*/}
              {/*  margin="dense"*/}
              {/*  defaultValue=""*/}
              {/*  value={entityFields?.blacklisted || ''}*/}
              {/*  onChange={(event) =>*/}
              {/*    onChange('generalFields', 'blacklisted',event.target.value)*/}
              {/*  }*/}
              {/*>*/}
              {/*  {blackListedOptions.map((option, index) => (*/}
              {/*    <MenuItem key={index} value={option.value}>*/}
              {/*      {option.label}*/}
              {/*    </MenuItem>*/}
              {/*  ))}*/}
              {/*</StyledTextField>*/}
              <FormControl
                fullWidth
                margin="dense"
              >
                <StyledInputLabel
                  id="select-is-resident-label"
                  htmlFor="select-is-resident-input"
                >
                  NL resident
                </StyledInputLabel>
                <StyledSelect
                  labelId="select-is-resident-label"
                  id="select-is-resident"
                  name="selectIsResident"
                  value={entityFields?.is_resident.toString() || ''}
                  label="NL resident"
                  onChange={(event: SelectChangeEvent) => onChange('generalFields', 'is_resident', event.target.value)
                  }
                  inputProps={{
                    id: 'select-is-resident-input',
                  }}
                >
                  {isResidentOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </StyledSelect>
              </FormControl>
              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  select*/}
              {/*  label="NL resident"*/}
              {/*  margin="dense"*/}
              {/*  defaultValue=""*/}
              {/*  value={entityFields?.is_resident || ''}*/}
              {/*  onChange={(event) =>*/}
              {/*    onChange('generalFields', 'is_resident', event.target.value)*/}
              {/*  }*/}
              {/*>*/}
              {/*  {isResidentOptions.map((option) => (*/}
              {/*    <MenuItem key={option.value} value={option.value}>*/}
              {/*      {option.label}*/}
              {/*    </MenuItem>*/}
              {/*  ))}*/}
              {/*</StyledTextField>*/}
            </Box>
            <Box sx={styles.fieldBlock}>
              <NumericTextField
                fullWidth
                label="K.P.N."
                type="text"
                name="kadaster_personal_number"
                errorFields={errorFields.kadaster_personal_number}
                setErrorFields={setErrorFields}
                margin="dense"
                value={entityFields?.kadaster_personal_number}
                onChange={(event) => onChange('generalFields', 'kadaster_personal_number', event.target.value)}
              />

              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  label="K.P.N."*/}
              {/*  margin="dense"*/}
              {/*  onChange={(e) =>*/}
              {/*    onChange('generalFields', 'kadaster_personal_number', e, -1)*/}
              {/*  }*/}
              {/*  value={entityFields?.kadaster_personal_number}*/}
              {/*/>*/}

              <NumericTextField
                fullWidth
                label="Kad. Rechthebbende"
                type="text"
                name="kadaster_objects_amount"
                errorFields={errorFields.kadaster_objects_amount}
                setErrorFields={setErrorFields}
                margin="dense"
                value={entityFields?.kadaster_objects_amount}
                onChange={(event) => onChange('generalFields', 'kadaster_objects_amount', event.target.value)}
              />

              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  label="Kad. Rechthebbende"*/}
              {/*  margin="dense"*/}
              {/*  onChange={(e) =>*/}
              {/*    onChange('generalFields', 'kadaster_objects_amount', e, -1)*/}
              {/*  }*/}
              {/*  value={entityFields?.kadaster_objects_amount}*/}
              {/*/>*/}

              <LinkTextField
                fullWidth
                label="Kad. link"
                type="text"
                name="kadaster_url"
                errorFields={errorFields.kadaster_url}
                setErrorFields={setErrorFields}
                margin="dense"
                value={entityFields?.kadaster_url}
                onChange={(event) => onChange('generalFields', 'kadaster_url', event.target.value)}
              />

              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  label="Kad. link"*/}
              {/*  margin="dense"*/}
              {/*  onChange={(e) =>*/}
              {/*    onChange('generalFields', 'kadaster_url', e, -1)*/}
              {/*  }*/}
              {/*  value={entityFields?.kadaster_url}*/}
              {/*/>*/}

              <LinkTextField
                fullWidth
                label="Link"
                type="text"
                name="url"
                errorFields={errorFields.url}
                setErrorFields={setErrorFields}
                margin="dense"
                value={entityFields?.url}
                onChange={(event) => onChange('generalFields', 'url', event.target.value)}
              />

              {/*<StyledTextField*/}
              {/*  fullWidth*/}
              {/*  label="Link"*/}
              {/*  margin="dense"*/}
              {/*  onChange={(e) => onChange('generalFields', 'url', e, -1)}*/}
              {/*  value={entityFields?.url}*/}
              {/*/>*/}
            </Box>
          </Box>
        )}
   </ ValidatedAccordion>
  );
};

export default GeneralFieldsBlock;
